import React, { Component } from 'react';
import createStyledComponent from '../utils/createStyledComponent.js';
import styles from './styles/index.js';
const ContextMenuWrapper = createStyledComponent(styles);
function isReactButtonElement(item) {
    return item.type === 'button';
}
export default class ContextMenu extends Component {
    constructor() {
        super(...arguments);
        this.onMouseUp = (e) => {
            e.currentTarget.blur();
        };
        this.onClick = (e) => {
            this.props.onClick(e.currentTarget.value);
        };
        this.menuRef = (c) => {
            this.menu = c;
        };
    }
    componentDidMount() {
        this.amendPosition();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.x !== this.props.x || prevProps.y !== this.props.y) {
            this.amendPosition();
        }
    }
    amendPosition() {
        const { x, y } = this.props;
        const { scrollTop, scrollLeft } = document.documentElement;
        const { innerWidth, innerHeight } = window;
        const rect = this.menu.getBoundingClientRect();
        let left = x + scrollLeft;
        let top = y + scrollTop;
        if (y + rect.height > innerHeight) {
            top = innerHeight - rect.height;
        }
        if (x + rect.width > innerWidth) {
            left = innerWidth - rect.width;
        }
        if (top < 0) {
            top = rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
        }
        if (left < 0) {
            left = rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
        }
        this.menu.style.top = `${top}px`;
        this.menu.style.left = `${left}px`;
    }
    renderItems() {
        return this.props.items.map((item) => {
            if (isReactButtonElement(item))
                return item;
            const value = item.value || item.name;
            return (React.createElement("button", { key: value, value: value, onMouseUp: this.onMouseUp, onClick: this.onClick }, item.name));
        });
    }
    render() {
        return (React.createElement(ContextMenuWrapper, { ref: this.menuRef, left: this.props.x, top: this.props.y, visible: this.props.visible }, this.renderItems()));
    }
}
